// extracted by mini-css-extract-plugin
export var section = "index-module--section--3EKCW";
export var titleContainer = "index-module--titleContainer--3riuJ";
export var header = "index-module--header--2TBtR";
export var primary = "index-module--primary--1aD_G";
export var secondary = "index-module--secondary--WOmER";
export var tertiary = "index-module--tertiary--3T2EN";
export var localhost = "index-module--localhost--2c0yH";